/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _class2, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _BioExamResultsReviewFormComponent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Store from "@ember-data/store";
import { action } from "@ember/object";
import RouterService from "@ember/routing/router-service";
import { service } from "@ember/service";
import { tracked } from "@glimmer/tracking";
import { ForcBaseArgs } from "core/components/forc/abstract/base-component";
import JournalEventBasedComponent from "core/components/forc/abstract/journal-event-based-component";
import JournalEventRetrievalStrategies from "core/components/forc/utils/journal-event-retrieval-strategies";
import { HprimPatient } from "core/models/apicrypt-message-received-journal-event";
import BioExamResult, { OriginalLine, RawFromHprim } from "core/models/bio-exam-result";
import BioExamResultsReceivedJournalEvent from "core/models/bio-exam-results-received-journal-event";
import BioExamObservation from "core/models/loinc";
import Patient from "core/models/patient";
import BioExamResultsService from "core/services/bio-exam-results";
import FetcherService from "core/services/fetcher";
import SemeiaSessionService from "core/services/session";
import deduplicate from "core/utils/bio-exam-results/deduplicate";
import parameterize from "core/utils/parameterize";
import { sortBy } from "core/utils/sort";
import trimLoincCode from "core/utils/trim-loinc-code";
import { Changeset, EmberChangeset } from "ember-changeset";
import lookupValidator from "ember-changeset-validations";
import { validatePresence } from "ember-changeset-validations/validators";
import { ValidationResult, ValidatorMap } from "ember-changeset/types";
import { runTask } from "ember-lifeline";
export let BioExamResultsChangeset = (_class = class BioExamResultsChangeset extends EmberChangeset {
  constructor(data) {
    super(data);
    _initializerDefineProperty(this, "results", _descriptor, this);
    this.results = data.results.map(result => Changeset(result, lookupValidator(this.validations), this.validations));
  }
  get validations() {
    return {
      code: validatePresence({
        presence: true,
        description: "Le code"
      }),
      unitValidated: this.validateUnit,
      valueValidated: this.validateValue
    };
  }
  validateUnit(_key, _accepted, _oldValue, changes, content) {
    // Return true if the HPRIM raw unit is defined
    if (content.rawUnit) return true;

    // When there are changes in the changeset
    if (Object.keys(changes).length) {
      const code = changes.code;
      if (code) {
        // Return true if the result is ignored
        if (code == "LOINC-ignore") return true;
        // Return true if the result is ADHOC
        if (code.startsWith("ADHOC")) return true;
        const obs = content.store.peekRecord("loinc", trimLoincCode(code));

        // Return true if the result is not ADHOC and the related
        // observation does not have known conversions
        if (!obs.hasAvailableUnits) return true;
      }

      // If the key `selectedRawUnit` is present in changes,
      // it means that the result has been standardize, so that a `rawUnit`
      // has been selected currently
      if (changes.selectedRawUnit) {
        return true;
      }

      // Otherwise return an error
      return "Unité à renseigner";
    }

    // If the key `selectedRawUnit` is present in content,
    // it means that the result has been standardize, so that a `rawUnit`
    // has been selected previously
    if (content.selectedRawUnit) {
      return true;
    }

    // When there are no changes
    // Return true if no LOINC is selected
    if (!content.bioExamObservation) return true;

    // Return true if the related observation does not have not-null conversions
    if (!content.bioExamObservation.hasAvailableUnits) return true;

    // Otherwise return an error
    return "Unité à renseigner";
  }
  validateValue(_key, _accepted, _oldValue, _changes, content) {
    const rawContent = content.resultHash.originalLine?.raw;
    if (!rawContent) return true;

    // This has to be modified, it's a quick workaround but we need to successfully handle ORU status
    if (!rawContent.segs) return true;
    if (rawContent.segs?.[0] == "RES") return true;
    if (rawContent.segs?.[4]) return true;

    // Otherwise return an error
    return "Valeur à renseigner";
  }
  get isDirty() {
    return this.results.some(changeset => changeset.isDirty);
  }
  get isPristine() {
    return this.results.some(changeset => changeset.isPristine);
  }
  get isValid() {
    return this.results.every(changeset => changeset.isValid) && super.isValid;
  }
  get isInvalid() {
    return this.results.some(changeset => changeset.isInvalid);
  }
  async validate() {
    await Promise.all([this.results.forEach(changeset => changeset.validate()), super.validate()]);
  }
  addResult(result, index) {
    const results = this.results;
    // If there is an index, insert the result after
    if (index) {
      const indexNb = parseInt(index) + 1;
      results.splice(indexNb, 0, Changeset(result, lookupValidator(this.validations), this.validations));
      this.results = [...results];
    } else {
      // otherwise push the result at the end of the results array
      this.results = [...results, Changeset(result, lookupValidator(this.validations), this.validations)];
    }
  }
  removeResult(index) {
    const results = this.results;
    results.splice(index, 1);
    this.results = results;
  }
  deduplicateResults(deduplicatedResults) {
    this.results = deduplicatedResults.map(result => Changeset(result, lookupValidator(this.validations), this.validations));
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "results", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "validateUnit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "validateUnit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "validateValue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "validateValue"), _class.prototype), _class);
/* eslint-disable parog-web/migrate-non-patch-forms */
let BioExamResultsReviewFormComponent = (_class2 = (_BioExamResultsReviewFormComponent = class BioExamResultsReviewFormComponent extends JournalEventBasedComponent {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "store", _descriptor2, this);
    _initializerDefineProperty(this, "fetcher", _descriptor3, this);
    _initializerDefineProperty(this, "session", _descriptor4, this);
    _initializerDefineProperty(this, "router", _descriptor5, this);
    _initializerDefineProperty(this, "bioExamResults", _descriptor6, this);
    _defineProperty(this, "autoSaveDraft", true);
    _initializerDefineProperty(this, "selectedOption", _descriptor7, this);
    _defineProperty(this, "retrieveJournalEvent", JournalEventRetrievalStrategies.sourceJournalEvent);
    _defineProperty(this, "stillDraft", false);
    _initializerDefineProperty(this, "resultsAreDirty", _descriptor8, this);
    _initializerDefineProperty(this, "patientIsDirty", _descriptor9, this);
    _initializerDefineProperty(this, "loincDuplicatesMap", _descriptor10, this);
    _initializerDefineProperty(this, "hasCoherentValueArray", _descriptor11, this);
    _defineProperty(this, "afterCompleted", () => {
      this.router.transitionTo("medics-web.protected.index.bio-exams.summary");
    });
    runTask(this, async () => {
      await this.changeset.validate("hasCoherentValueValidated");
    });
    if (this.model.isFromHprim) {
      const allPatients = this.store.peekAll("patient");

      // Patient born the same day
      // OR having the same last name
      const similarPatients = allPatients.filter(patient => {
        const bornTheSameDay = patient.birthday?.toLocaleDateString() == new Date(this.model.lastApicryptMessage.hprimPatient.birthday).toLocaleDateString();
        const withSameLastName = parameterize(patient.lastName) == parameterize(this.model.lastApicryptMessage.hprimPatient.lastName);
        return bornTheSameDay || withSameLastName;
      });
      this.matchablePatients = [...new Set(similarPatients.concat(this.args.patient || []))].sort(sortBy("firstName"));
    } else {
      this.matchablePatients = [this.args.patient];
    }
  }
  get validations() {
    return {
      loincUnicityValidated: this.checkLoincUnicity,
      hasCoherentValueValidated: this.checkHasCoherentValue
    };
  }
  deduplicateResults(results) {
    const resultsGroupByLoinc = results.reduce((loincMaps, result) => {
      // If loincMap doesn't exist, create it with empty array
      if (!loincMaps.has(result.code)) {
        loincMaps.set(result.code, []);
      }

      // Push current index to indexes array of the loincMap
      loincMaps.get(result.code).push(result);
      return loincMaps;
    }, new Map());
    resultsGroupByLoinc.forEach((results, loinc) => {
      if (loinc.startsWith("ADHOC")) return;
      if (loinc.endsWith("ignore")) return;
      if (results.length > 1) {
        const epsilon = this.store.peekRecord("loinc", trimLoincCode(loinc)).identicalValuesEpsilonRatio;
        resultsGroupByLoinc.set(loinc, deduplicate(epsilon, results));
      }
    });
    return [...resultsGroupByLoinc.values()].flat();
  }
  checkHasCoherentValue(_key, _accepted, _oldValue, changes, content) {
    const results = Object.keys(changes).includes("results") ? changes.results : content.results;
    this.hasCoherentValueArray = results.map(result => result.hasCoherentValue);

    // If there's no incoherent values, it's valid
    return !this.hasCoherentValueArray.includes(false);
  }
  checkLoincUnicity(_key, _accepted, _oldValue, changes, content) {
    const results = Object.keys(changes).includes("results") ? changes.results : content.results;
    const loincDuplicatesMap = results.reduce((loincMaps, result, index) => {
      // Next if the result is ignored
      if (result.isIgnored) return loincMaps;
      // Next if the result is ADHOC
      if (result.isAdhoc) return loincMaps;

      // If loincMap doesn't exist, create it with empty indexes array
      if (!loincMaps.find(loincMap => loincMap.loinc == result.code)) {
        loincMaps.push({
          loinc: result.code,
          indexes: []
        });
      }

      // Push current index to indexes array of the loincMap
      loincMaps.find(loincMap => loincMap.loinc == result.code).indexes.push(index);
      return loincMaps;
    }, []).filter(loincMap => loincMap.indexes.length > 1);
    if (loincDuplicatesMap?.length) {
      this.loincDuplicatesMap = loincDuplicatesMap;
      return false;
    }
    this.loincDuplicatesMap = undefined;
    return true;
  }
  get bioExamResultsChangeset() {
    if (this._bioExamResultsChangeset) return this._bioExamResultsChangeset;

    // Extend Changeset class: https://github.com/poteto/ember-changeset#extending-the-base-ember-changeset-class
    this._bioExamResultsChangeset = Changeset({
      results: this.model.results
    }, lookupValidator(this.validations), this.validations, {
      changeset: BioExamResultsChangeset
    });
    return this._bioExamResultsChangeset;
  }
  async updateBioExamResultsChangeset(index, value) {
    this.changeset.results[index] = value;
    await this.validateChangesets();
    this.resultsAreDirty = true;
  }
  async addResultToChangeset(index) {
    const result = BioExamResult.newManualRes({
      code: "ADHOC",
      value: "",
      isDraft: true,
      store: this.store
    });
    this.bioExamResultsChangeset.addResult(result, index);

    // Back propagate changes on main changeset
    let results = this.changeset.results;
    if (index) {
      const indexNb = parseInt(index) + 1;
      results.splice(indexNb, 0, result);
      results = [...results];
    } else {
      // otherwise push the result at the end of the results array
      results = [...results, result];
    }
    this.changeset.results = results;
    await this.validateChangesets();
  }
  async removeResultFromChangeset(index) {
    this.bioExamResultsChangeset.removeResult(index);

    // Back propagate changes on main changeset
    const results = this.changeset.results;
    results.splice(index, 1);
    this.changeset.results = results;
    await this.validateChangesets();
  }
  async updateJePatient(patientId) {
    let newPatient = null;
    if (patientId) {
      newPatient = this.store.peekRecord("patient", patientId);
    }
    this.changeset.set("patient", newPatient);

    /**
     * When updating the selected patient, if the current tab is `summary`, all
     * bio exam results JEs of the selected patient need to be loaded to display
     * the summary table (even those not from hprim)
     */
    if (this.selectedOption == "summary") {
      await this.loadSelectedPatientBioExamResultsJes();
    }
    this.orderedFileAttachments.forEach(fileAttachment => {
      fileAttachment.patient = this.changeset.get("patient");
      fileAttachment.save();
    });
    this.patientIsDirty = true;
  }

  /**
   * When selecting the tab `summary`, all bio exam results JEs of the selected
   * patient need to be loaded to display the summary table (even those not from
   * hprim)
   */
  async updateTab(selectedOption) {
    if (selectedOption == "summary") {
      await this.loadSelectedPatientBioExamResultsJes();
    }
    this.selectedOption = selectedOption;
  }

  /**
   * Search for existing duplicates, and return the list of result index or an empty array.
   */
  duplicateIndexes(index) {
    if (!this.loincDuplicatesMap) return [];
    return this.loincDuplicatesMap.find(loincDuplicateMap => loincDuplicateMap.indexes.includes(parseInt(index)))?.indexes || [];
  }

  /**
   * Load selected patient's bio exam results JEs on demand
   * and their corresponding file attachments
   */
  async loadSelectedPatientBioExamResultsJes() {
    if (this.changeset.get("patient")) {
      await this.fetcher.loadRecords("bio-exam-results-received-journal-event", {
        filter: {
          patient_id: this.changeset.get("patient").id
        },
        include: ["file-attachments", "apicrypt-message-received-journal-events"].join(",")
      });
    }
  }
  get canSaveWithoutApproving() {
    return !!(this.resultsAreDirty && this.bioExamResultsChangeset.isValid || this.patientIsDirty);
  }
  get isDirty() {
    return this.bioExamResultsChangeset.isValid && this.changeset.isValid;
  }
  async validateChangesets() {
    await this.bioExamResultsChangeset.validate(); // Will validate the unit / value / code presence on each results
    await this.changeset.validate(); // Will validate that there's no LOINC duplicates in the results array
  }
  async saveWithoutApproving() {
    this.stillDraft = true;
    await this.onSubmit.perform();
  }
  get model() {
    const bioJe = this.retrievedJournalEvent;
    this.deduplicateResults(bioJe.results);
    Object.defineProperty(this, "model", {
      value: bioJe,
      writable: false
    });
    return this.model;
  }
  get orderedFileAttachments() {
    return this.model.orderedFileAttachments.reverse();
  }
  beforeValidation() {
    const results = this.changeset.get("results");
    const codeListBefore = JSON.stringify(results.map(res => res.code));
    const deduplicatedResults = this.deduplicateResults([...results]);
    const codeListAfter = JSON.stringify(deduplicatedResults.map(res => res.code));

    // If the code list is the same before and after the deduplication algorithm
    // it means that there is no duplicate
    if (codeListBefore == codeListAfter) {
      return;
    }

    // Update the results in the main changeset and in the bioExamResultsChangeset
    // if there was a deduplication
    this.bioExamResultsChangeset.deduplicateResults(deduplicatedResults);
    this.changeset.set("results", deduplicatedResults);
  }
  async save() {
    if (!this.isDirty) {
      return;
    }
    this.changeset.isDraft = this.stillDraft;
    this.changeset.results.forEach(bioExamResult => {
      bioExamResult.isDraft = this.stillDraft;
    });
    const je = await this.changeset.save();
    if (!this.stillDraft) {
      this.bioExamResults.loadBioExamDraftCount();
      await this.store.createRecord("bio-exam-results-approved-journal-event", {
        bioExamResultsReceivedJournalEvent: je,
        patient: je.patient,
        occurredAt: new Date()
      }).save();

      // We unload notifications related to BioExamResultsReceivedJournalEvents for the patient in case of an approval
      // because the backend will create one for the approval, but we have no logic to update the front
      // if the back-end archive an existing notification in the user store
      const notifications = je.patient.bioExamResultsReceivedJournalEvents.flatMap(bioJe => bioJe.notificationTriggeredJournalEvents);
      for (const notification of notifications) {
        notification.unloadRecord();
      }
    }
  }
}, _defineProperty(_BioExamResultsReviewFormComponent, "fullComponentId", "bio-exam-results/review-form"), _defineProperty(_BioExamResultsReviewFormComponent, "forcDisplayName", "Résultats biologiques"), _defineProperty(_BioExamResultsReviewFormComponent, "journalEventClass", BioExamResultsReceivedJournalEvent), _BioExamResultsReviewFormComponent), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "fetcher", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "bioExamResults", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "selectedOption", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.model.orderedFileAttachments.length ? "pdf" : "results";
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "resultsAreDirty", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "patientIsDirty", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "loincDuplicatesMap", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "hasCoherentValueArray", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "deduplicateResults", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "deduplicateResults"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "checkHasCoherentValue", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "checkHasCoherentValue"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "checkLoincUnicity", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "checkLoincUnicity"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateBioExamResultsChangeset", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "updateBioExamResultsChangeset"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "addResultToChangeset", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "addResultToChangeset"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "removeResultFromChangeset", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "removeResultFromChangeset"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateJePatient", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "updateJePatient"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateTab", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "updateTab"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "duplicateIndexes", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "duplicateIndexes"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "saveWithoutApproving", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "saveWithoutApproving"), _class2.prototype), _class2);
export { BioExamResultsReviewFormComponent as default };